import * as actions from 'state/actions';
import Rudderstack from 'utils/Rudderstack';
import Validator from 'utils/Validator';

const AccountRegistrationController = class {
  static pushEmail = (event, store, isLogin) => {
    event.preventDefault();

    const $form = event.target;
    const email = $form.elements['customer[email]'].value;
    const hasValidEmailAddress = Validator.isEmail(email);
    const acceptsMarketing = isLogin
      ? null
      : $form?.elements['customer[marketing_subscription]']?.checked;

    if (hasValidEmailAddress) {
      store.dispatch(
        actions.signUpForNewsletter({
          emailAddress: email,
          acceptsMarketing,
          origination: 'myAccount',
        })
      );
      Rudderstack.accountCreationCompleted();
    }
    $form.submit();
  };

  static subscribeToAccountCreationFormStart = () => {
    const $formStart = document.getElementById('Email');

    $formStart.addEventListener(
      'blur',
      () => {
        return Rudderstack.accountCreationStarted();
      },
      { once: true }
    );
  };

  static subscribeToFormSubmit = store => {
    const $form = document.getElementById('create_customer');

    $form.addEventListener('submit', event =>
      AccountRegistrationController.pushEmail(event, store)
    );
  };

  static subscribeToLoginFormSubmit = store => {
    const $form = document.getElementById('customer_login');

    $form.addEventListener('submit', event =>
      AccountRegistrationController.pushEmail(event, store, true)
    );
  };

  static init = store => {
    AccountRegistrationController.subscribeToFormSubmit(store);
    AccountRegistrationController.subscribeToLoginFormSubmit(store);
    AccountRegistrationController.subscribeToAccountCreationFormStart();
  };
};

export default AccountRegistrationController;
